import {useMutation} from "@tanstack/react-query";
import {setCustomerOfferChapterCommercialOptionsMutationOptions} from "./set-customer-offer-chapter-commercial-options.mutation-options";

export function useSetCustomerOfferChapterCommercialOptions(id: string, chapterId: string) {
  return useMutation(setCustomerOfferChapterCommercialOptionsMutationOptions(id, chapterId));
}
